<!-- Page -->
<div class="col" style="width: 100%; overflow: auto">
  <div class="row full-width card-height">
    <!-- Single Tab Group for Both Sections -->
    <mat-card class="padding margin all full-width">
      <mat-card-header class="orders-header">
        <mat-card-title>{{ selectedTab.name }}</mat-card-title>
        <div>
          <mat-tab-group
            class="tabs margin left"
            mat-stretch-tabs
            [(selectedIndex)]="selectedTabIndex"
            (selectedTabChange)="onChangeTab($event)"
          >
            <mat-tab *ngFor="let tab of tabs" [label]="tab.name"></mat-tab>
          </mat-tab-group>
        </div>
      </mat-card-header>

      <!-- Orders Content -->
      <div *ngIf="selectedTabIndex === 0">
        <app-order-info [orders]="orderDetails" [structure]="structure" [keySystem]="keySystem"></app-order-info>
      </div>

      <!-- Audit Trail Content -->
      <div *ngIf="selectedTabIndex === 1">
        <app-audit-trail 
          [structureId]="structure?.id" 
          [keySystemId]="keySystem?.id">
        </app-audit-trail>
      </div>
    </mat-card>
  </div>
</div>
